module.exports = __webpack_public_path__ + "static/media/msd.b8c1ad48.png";